import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import "./CTAPanel.scss"
import {
  BackgroundKeyToColor,
  // GeneralSizeKeyToPaddingNumber,
  // GeneralHeightKeyToBarHeight,
} from "../../../utils/datasources"
import { resolveRichText } from "../../../utils/richText"
import Buttons from "../../internal/buttons/Buttons";

const CTAPanel = ({ blok }) => {
  const {
    panel_text,
    content_color,
    cta_card_color,
    cta_text,
    cta_link,
    is_modal,
    modal_id,
  } = blok
  const buttonProps = {
    text: cta_text,
    url: cta_link,
    isModal: is_modal,
    textColor: content_color,
    modalId: modal_id,
  }
  const backgroundColor = BackgroundKeyToColor(cta_card_color)
  return (
    <PanelWrapper blok={blok}>
    <div className="shadow-cards">
      <Container className="cta-panel-container panel-radius" style={{backgroundColor: backgroundColor}}>
        <Row>
          <Col md={9} sm={12} className="justify-content-center text-container">
          {panel_text ? (
              <div style={{color: content_color}} dangerouslySetInnerHTML={resolveRichText(panel_text)}></div>
            ) : null}
          </Col>
          <Col md={3} sm={12} className="justify-content-center cta-container" style={{margin: "auto", textAlign: "center"}}>
            {cta_text ? (
              <Buttons buttonProps={buttonProps} />
            ): null}
          </Col>
        </Row>
      </Container>
    </div>
  </PanelWrapper>
  )
}

export default CTAPanel
